import { Notification } from '@/app/notifications/entities/notification.entity'

export interface SiteNotificationState {
    notifications: Notification[]
}

export const state: SiteNotificationState = {
    notifications: []
}
